<template>
  <div id="app">
	  <div class="appbox">
	  	  <router-view/>
  	</div>
  </div>
</template>

<script>
export default {
  name: 'App',
  data(){
  		return{
  			
  		}
  }
}
</script>

<style>
body{
		width: 100%;
		height: 100%;
		/*overflow: hidden;*/
		background:rgba(254,254,254,1);
}
#app{
  	width: 100%;
		height: 100%;
}
.appbox{
		width: 100%;
		height: 100%;
}


</style>



// WEBPACK FOOTER //
// src/App.vue